import gql from 'graphql-tag'

export const GET_STATS = gql`
  query {
    approvedHero: heroCount(status: APPROVED)
    pendingHero: heroCount(status: PENDING)
    materialCount
    locationCount
    userCount
    barcodeProductCount
  }
`

export const GET_USER_RANKINGS = gql`
  query getUserRanking($month: String!) {
    userRankings: ranking(month: $month) {
      id
      month
      discoverers {
        id
        user {
          id
          name
        }
        discoverCount
      }
    }
  }
`
